module.exports = __webpack_public_path__ + "img/扶梯7.196c88ee.png";